// src/services/pluginService.js

class PluginService {
    constructor() {
        this.extensionId = null;
        this.isConnected = false;
        this.listeners = new Map();
    }

    // 初始化插件连接
    async initialize() {
        try {
            // 检查是否在Chrome扩展环境中
            if (typeof chrome === 'undefined' || !chrome.runtime) {
                throw new Error('Not in Chrome extension environment');
            }

            // 尝试通过消息获取扩展ID
            return new Promise((resolve, reject) => {
                try {
                    // 临时解决方案：设置一个默认的扩展ID
                    // 用户需要手动设置正确的扩展ID
                    this.extensionId = null;
                    this.isConnected = false;
                    
                    // 尝试通过消息获取扩展ID
                    // 注意：在没有扩展ID时，不能调用chrome.runtime.sendMessage
                    // 所以这里直接设置为未连接状态
              
                    this.isConnected = false;
                    resolve(null);
                } catch (error) {
              
                    this.isConnected = false;
                    resolve(null);
                }
            });
        } catch (error) {
        
            this.isConnected = false;
            throw error;
        }
    }

    // 发送消息到插件
    sendMessage(action, data = {}) {
        if (!this.isConnected || !this.extensionId) {
            throw new Error('Plugin not connected');
        }

        return new Promise((resolve, reject) => {
            const message = { action, ...data };
            
            try {
                chrome.runtime.sendMessage(this.extensionId, message, (response) => {
                    if (chrome.runtime.lastError) {
                        reject(new Error(chrome.runtime.lastError.message));
                    } else if (response && response.status === 'success') {
                        resolve(response);
                    } else {
                        reject(new Error('Plugin response error'));
                    }
                });
            } catch (error) {
                reject(new Error(`Failed to send message: ${error.message}`));
            }
        });
    }

    // 打开搜索页面
    async openSearch(query, platform, autoSwitchValue = 'true') {
        return this.sendMessage('openSearch', {
            query,
            platform,
            autoSwitchValue
        });
    }

    // 监听插件数据
    listenForData(callback) {
        const listener = (message, sender, sendResponse) => {
            if (message.action === 'connectBackground') {
                sendResponse({ status: 'success' });
                
                // 建立长连接
                const port = chrome.runtime.connect({ name: 'myConnection' });
                
                port.onMessage.addListener((msg) => {
                    if (msg.keepAlive && msg.data) {
                        callback(msg.data);
                    }
                });

                port.postMessage({ greeting: 'hello from content script' });
            }
        };

        chrome.runtime.onMessage.addListener(listener);
        this.listeners.set('data', listener);
    }

    // 清理监听器
    cleanup() {
        this.listeners.forEach((listener) => {
            chrome.runtime.onMessage.removeListener(listener);
        });
        this.listeners.clear();
    }

    // 检查插件状态
    getStatus() {
        return {
            isConnected: this.isConnected,
            extensionId: this.extensionId
        };
    }

    // 手动设置扩展ID（用于测试或手动配置）
    setExtensionId(id) {
        this.extensionId = id;
        this.isConnected = true;
    }
}

// 创建单例实例
const pluginService = new PluginService();
export default pluginService;